import { useQuery } from '@tanstack/react-query';

import { getRecentWork } from '../api';
import { homeQuery } from '../data/query-keys';
import { ProductData } from '../types/recent-work';

export const useRecentWork = () => {
  return useQuery<ProductData[], Error>({
    queryKey: homeQuery.getRecentWork,
    queryFn: getRecentWork,
    staleTime: 5000,
  });
};
